import helpApi from '@/api/v1/help';
import texts from '@/helpers/texts';

export default {
  namespaced: true,

  state: {
    help: texts.helpText,
    isProcessing: false,
  },

  mutations: {
    SET_HELP_TEXT(state, helpText) {
      state.help = helpText;
    },
    CHANGE_PROCESSING_STATUS(state, status) {
      state.isProcessing = status;
    },
  },

  actions: {
    getHelpText({ commit, rootState }) {
      commit('CHANGE_PROCESSING_STATUS', true);

      helpApi.show(rootState.auth.user.departmentId)
        .then((resp) => {
          commit('SET_HELP_TEXT', resp.data.text);
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    updateHelpText({ commit, rootState }, text) {
      commit('CHANGE_PROCESSING_STATUS', true);

      return helpApi.update(rootState.auth.user.departmentId, { text })
        .then((resp) => {
          commit('SET_HELP_TEXT', resp.data.text);
        })
        .finally(() => {
          commit('CHANGE_PROCESSING_STATUS', false);
        });
    },

    changeProcessingStatus({ commit }, status) {
      commit('CHANGE_PROCESSING_STATUS', status);
    },
  },
};
